// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2v-3";
export var dialog = "_2v-0";
export var divClassnameSwatch = "_2v-8";
export var flexSwatch = "_2v-4";
export var header = "_2v-1";
export var styleAttributeSwatch = "_2v-7";
export var swatch = "_2v-2";
export var textHeaderSwatch = "_2v-5";
export var webSwatch = "_2v-6";